import { equals, isEmpty, reject } from 'ramda';
import { ChoiceListItem } from '@sunwebgroup/ui-components';
import type { CheckedChangedEventHandler } from '@sunwebgroup/ui-components';

import { useMultiSelectFilter } from '../../../../domain/hooks';
import { useIntl } from '@/intl';
import FilterGroup from './FilterGroup';
import { ShowMore } from '../../../../../../common/components/ShowMore';
import { createSearchFilterClickEvent } from '../../../../domain/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';

export function MealPlanFilter() {
  const intl = useIntl();
  const { sendEvent } = useAnalytics();
  const { isFetching, options, selectedValues, setSelection } = useMultiSelectFilter('Mealplan');

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection([...selectedValues, value]);
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'boardType',
          result: [...selectedValues, value].join(','),
        })
      );
    }

    if (!checked) {
      setSelection(reject(equals(value), selectedValues));
    }
  };

  if (isEmpty(options)) return null;

  return (
    <FilterGroup
      title={intl.formatMessage({ id: 'accommodation_care_label' })}
      explanation={intl.formatMessage({ id: 'search_filter_meal_plan_explanation_popover_content' })}
      explanationReadMoreLink={intl.formatMessage({
        id: 'search_filter_meal_plan_explanation_popover_read_more_link',
      })}
      explanationReadMoreLinkText={intl.formatMessage({
        id: 'search_filter_meal_plan_explanation_popover_read_more_link_text',
      })}
      defaultOpen
    >
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ChoiceListItem
            choiceListItemType="checkbox"
            key={name}
            value={value}
            checked={selectedValues.includes(value)}
            label={name}
            quantity={resultsCount}
            onCheckedChange={handleFilterChange}
            disabled={isFetching}
          />
        ))}
      </ShowMore>
    </FilterGroup>
  );
}
